import React, { useContext, useEffect } from 'react'
import DashboardNavbar from '../../components/Navbar/DashboardNavbar';
import { Outlet, useNavigate } from 'react-router-dom';
import Cookie from "js-cookie"
import CommonContext from '../../hooks/CommonContext';
import axiosInstance from '../../services/api/axiosInstance';
import toast from 'react-hot-toast';

const ProfessionalHome = () => {
    const pageRender = useNavigate();

    const { setSubscriptionExpired } = useContext(CommonContext);

    const professionalPageDashboardMenu = ["Home", "Learning", "Community", "Jobs"];


    const queryParams = new URLSearchParams(window.location.search);
    const authenticationToken = queryParams.get("token");
    const user_id = queryParams.get("user_id");
    if (authenticationToken || user_id) {
        var uri = window.location.toString();
        if (uri.indexOf("?") > 0) {
            var clean_uri = uri.substring(0, uri.indexOf("?"));
            window.history.replaceState({}, document.title, clean_uri);
        }

        if (authenticationToken) {
            Cookie.set("Token", authenticationToken);
        }
    }


    useEffect(() => {
        //validating user for recommendation
        if (user_id) {
            if (Cookie.get("_id") !== user_id) {
                Cookie.remove("pToken")
                Cookie.remove("_id")

                pageRender("/")

                setTimeout(()=>{
                    toast.error("Not allowed")
                },100)
            }
        }

        const get_payment_status = async () => {
            try {
                const res = await axiosInstance.get('/get_payment_status_professional')

                if (res.data.error_code === 300) {
                    if (window.location.pathname !== '/professional/home') {
                        pageRender('/professional/home', { replace: true })
                    }

                    setSubscriptionExpired(true)
                } else {
                    if (res.data.error_code === 0) {
                        setSubscriptionExpired(false)
                    }
                }
            } catch (err) {
                console.log(err)
            }
        }
        get_payment_status();

    }, [])


    return (
        <>
            <DashboardNavbar
                profileImage="https://github.com/mdo.png"
                profileName="George Martin"
                dashboadMenus={professionalPageDashboardMenu}
            />

            <Outlet />
        </>
    )
}

export default ProfessionalHome
